<template>
<div>
<div class="main-container" v-show="!isShow">
  <div class="search-box">
    <div class="search-item">
      <label>商品名：</label>
      <a-input placeholder="请输入" v-model="searchTerm.mdseName" />
    </div>
    <div class="search-item" style="position:relative;">
      <label>商品类目：</label>
      <a-select 
        v-model="searchTerm.primaryCategoryId"   
        @select="handleCategoryChange" 
        placeholder="请选择大类" 
        :getPopupContainer="triggerNode => triggerNode.parentNode"
        option-filter-prop="children" 
        show-search 
        allowClear
      >
        <a-select-option v-for="category in categoryList" :key="category.id" >
          {{ category.categoryName }}
        </a-select-option>
      </a-select>
      <a-select 
        v-model="searchTerm.secondaryCategoryId"  
        v-show="searchTerm.primaryCategoryId" 
        placeholder="请选择小类"  
        @select="handleSecCategoryChange"
        :getPopupContainer="triggerNode => triggerNode.parentNode"
        option-filter-prop="children" 
        show-search 
        allowClear
      >
        <a-select-option v-for="secCategory in secCategoryList" :key="secCategory.id">
          {{ secCategory.categoryName}}
        </a-select-option>
      </a-select>
    </div>
    <br>
    <div class="search-item">
      <label>供应商账号名：</label>
      <a-input placeholder="请输入" v-model="searchTerm.supplierAlias" />
    </div>
    <div class="search-item">
      <label>供应商账号：</label>
      <a-input placeholder="请输入" v-model="searchTerm.supplierAccount" />
    </div>
    <div class="search-btn">
      <a-button type="primary" @click="search">查询</a-button>
      <a-button @click="reset">重置</a-button>
    </div>
  </div>
  <!-- 规格状态 10:待审核 20:审核不通过 30:审核通过 40:预警商品 50:已下架 -->
  <a-tabs type="card" @change="callback">
    <a-tab-pane :key="1" tab="全部">
    </a-tab-pane>
    <a-tab-pane :key="10" tab="待审核">
    </a-tab-pane>
    <a-tab-pane :key="30" tab="审核通过">
    </a-tab-pane>
    <a-tab-pane :key="20" tab="审核不通过">
    </a-tab-pane>
    <a-tab-pane :key="40" tab="库存预警">
    </a-tab-pane>
    <a-tab-pane :key="50" tab="已下架">
    </a-tab-pane>
  </a-tabs>
  <a-table 
    :locale="{emptyText: '暂无数据'}"
    rowKey="variantId" 
    :columns="columns" 
    :data-source="data" 
    @change="handleTableChange" 
    :pagination="pagination"  
    style="margin-top: 12px;"
  >
    <span slot="mdseName" slot-scope="text" class="mdseName">
      <img :src="text.skuImgPath" alt="">
      <span :title="text.mdseName">{{text.mdseName}}</span>
    </span>
    <span slot="variantNameObject" slot-scope="text">{{text|variantF}}</span>
    <span slot="distributePrice" slot-scope="text" >{{text|toFixed2}}</span>
    <span slot="supplyPrice" slot-scope="text,r" >{{text|toFixed2}}
			<a-tooltip 
        placement="bottom"
        :getPopupContainer="
        triggerNode => {
          return triggerNode.parentNode || document.body;
        }"
      >
        <template slot="title"><span>链接价格低于出货价</span></template>
        <a-icon type="exclamation-circle" :style="{  color: '#FF4D4F', }" v-show="r.itemPrice<r.supplyPrice"/>
      </a-tooltip>
    </span>
    <span slot="gapPrice" slot-scope="text" >{{text|toFixed2}}</span>
    <span slot="variantStatus" slot-scope="text" >{{text|statusFormat}}</span>
    <a slot="action" slot-scope="text,record" @click="openModal(record.variantId)">查看详情</a>
    <span slot="distributePrice">渠道价(元)
      <a-tooltip placement="bottom"
        :getPopupContainer="
        triggerNode => {
          return triggerNode.parentNode || document.body;
        }"
      >
        <span slot="title">提供给渠道商的价格</span>
        <a-icon type="exclamation-circle" />
      </a-tooltip>
    </span>
    <span slot="supplyPrice">进货价(元)
      <a-tooltip placement="bottom"
          :getPopupContainer="
          triggerNode => {
            return triggerNode.parentNode || document.body;
          }"
        >
        <span slot="title">从供应商进货的价格</span>
        <a-icon type="exclamation-circle" />
      </a-tooltip>
    </span>
    <span slot="gapPrice">价差(元)
      <a-tooltip placement="bottom"
          :getPopupContainer="
          triggerNode => {
            return triggerNode.parentNode || document.body;
          }
        ">
        <span slot="title">价差=渠道价-进货价</span>
        <a-icon type="exclamation-circle" />
      </a-tooltip>
    </span>
  </a-table>
</div>
<router-view/>
  </div>
</template>
<script>
import page from "@/assets/mixin/page.js";
const columns = [
  {
    title: '商品名',
    key: 'mdseName',
    width:'20%',
    scopedSlots: { customRender: 'mdseName' },
  },{
    title: '规格',
    dataIndex: 'variantNameObject',
    key: 'variantNameObject',
    scopedSlots: { customRender: 'variantNameObject' },
    width:'12%',
  },{
    // title: '渠道价(元)',
    dataIndex: 'distributePrice',
    // sorter:true,
    slots: { title: 'distributePrice' },
    scopedSlots: { customRender: 'distributePrice' },
  },{
    // title: '进货价(元)',
    key: 'supplyPrice',
    dataIndex: 'supplyPrice',
    // sorter:true,
    slots: { title: 'supplyPrice' },
    scopedSlots: { customRender: 'supplyPrice' },
  },{
    // title: '价差(元)',
    key: 'gapPrice',
    dataIndex: 'gapPrice',
    slots: { title: 'gapPrice' },
    scopedSlots: { customRender: 'gapPrice' },
  },{
    title: '库存',
    dataIndex: 'stockNum',
    key: 'stockNum',
    // sorter:true,
    width:'8%',
  },{
    title: '供应商名',
    dataIndex: 'supplierAlias',
    width:"9%",
    ellipsis: true,
    key: 'supplierAlias',
  },
  {
    title: '状态',
    key: 'variantStatus',
    dataIndex:'variantStatus',
    width:"9%",
    scopedSlots: { customRender: 'variantStatus' },
  },
  {
    title: '提交时间',
    dataIndex: 'createTime',
    key: 'createTime',
    width:"9%",
    ellipsis: true,
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
];

export default {
  mixins: [page],
  components:{},
  data() {
    return {
      categoryList: [],
      secCategoryList: [],
      data:[],
      columns,
			searchTerm:{
				primaryCategoryId:undefined,
				secondaryCategoryId:undefined,
			},
      //10:待审核 20:审核不通过 30:审核通过 40:已授权 45:预警商品 50:已下架
      // · 商品状态下拉筛选：全部商品、待审核、审核不通过、审核通过待授权、已授权、
      stateOptions:[
        {label:'全部商品',value:'-1'},
        {label:'待审核',  value:'10'},
        {label:'审核不通过',value:'20'},
        {label:'审核通过',value:'30'},
        {label:'已授权',  value:'40'},
        {label:'预警商品',value:'45'},
        {label:'已下架',  value:'50'},
      ]
    };
  },
  filters:{
    variantF(value) {
      if (!(value.values instanceof Array)) {
        return "--";
      }
      let label = "";
      value.values.forEach(item => {
        label += item + "、";
      });
      return label.substr(0, label.length - 1);
    },
     statusFormat(value) {
      switch (value) {
        case 10:
          return "待审核";
          break;
        case 20:
          return "审核不通过";
          break;
        case 30:
          return "审核通过";
          break;
        case 40:
          return "预警商品";
          break;
        case 50:
          return "已下架";
          break;
      }
    }
  },
  created(){
    this.getdata();
    this.getCatagory();
  },
   computed: {
     isShow() {
      return this.$route.name === "spec-detail";
    },
  },
  methods:{
    /* 搜索栏相关方法 */
    getCatagory() {
      this.$http.get("primaryCategory/getPriCateSet").then(res => {
        this.categoryList = res.data;
      });
    },
    getsecCategory() {
      let params = {};
      params.primaryCategoryId = this.searchTerm.primaryCategoryId;
      this.$http.get("secondaryCategory/getSndCateSet", { params }).then(res => {
        this.secCategoryList = res.data;
      });
    },
    handleCategoryChange(input, option) {
      this.getsecCategory();
			this.searchTerm.secondaryCategoryId = undefined;
    },
    handleSecCategoryChange(){
      this.$forceUpdate();
    },
    callback(key) {
      this.pagination.current =1;
      this.searchTerm.variantStatus = key ===1?'':key;
      this.getdata();
    },
    search(){
      this.pagination.current = 1;
      this.getdata();
    },
    reset(){
      this.pagination.current = 1;
      const variantStatus = this.searchTerm.variantStatus;
      this.searchTerm = {
        primaryCategoryId:undefined,
				secondaryCategoryId:undefined,
        variantStatus,
      };
      this.getdata();
    },
    getdata(){
      let params = {...this.searchTerm}
      if (this.searchTerm&&this.searchTerm.status=='-1') {
        params.status = ''
      }
      params.pageNum = this.pagination.current;
      this.$http.post('merchandise/queryVariantList',params).then(res=>{
        this.data = res.rows;
        this.pagination.total = res.count;
      })
    },
    openModal(params){
      this.$router.push({name:'spec-detail',query:{id:params}})
    }
  }
};
</script>
<style lang="less" scoped>
.mdseName{
  display: flex;
  align-items:center;
  img{
    margin-right: 8px;
    width: 60px;
    height: 60px;
	}
	span{
		// display: inline-block;
		line-height: 20px;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		word-wrap: break-word;
		word-wrap:break-word;
		white-space: pre-wrap;
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;/*重点，不能用block等其他*/
		-webkit-line-clamp: 2;/*重点IE和火狐不支持*/
		-webkit-box-orient: vertical;/*重点*/
	}
}
.search-box{
  padding: 29px 24px;
  margin-bottom: 24px;
  background-color: rgb(247, 248, 249);
  label{
    display:inline-block;
    width: 98px;
    text-align: right;
  }
  .search-item{
    display: inline-block;
    margin-bottom: 16px;
  }
  .search-btn{
    margin-left: 98px;
    .ant-btn{
      margin-right: 8px;
    }
  }
  .ant-select{
    width: 216px;
  }
  .ant-input{
    width: 216px;
    margin-right: 28px;
  }
}
.table-btn{
  .ant-btn{
    margin-right: 12px;
  }
  .last-btn{
    float: right;
    margin-right: 0;
  }
}
.ant-checkbox-wrapper{
  margin:0 24px;
  /deep/.ant-checkbox{
    margin-right: 16px;
  }
}
/deep/.ant-table-tbody > tr > td {
  padding: 16px 10px;
}
/deep/.ant-table-thead > tr > th {
  padding: 16px 10px;
}

</style>
